import { SSRRuleCreateRequest } from '../../../../integrated-client/models';

export interface IBookingCreateManagerV2SSREditorData extends SSRRuleCreateRequest {}

export interface IEditorData {
  bookingCreateManagerSSREditorData: IBookingCreateManagerV2SSREditorData;
  validation?: any;
}

export class BookingCreateManagerV2SSREditorData implements IBookingCreateManagerV2SSREditorData {
  id?: string | null;
  disabled?: boolean;
  description?: string | null;
  comment?: string | null;
  contactEmail?: string | null;
  contactMobile?: string | null;
  allowEdit?: boolean;

  constructor() {
    this.disabled = false;
  }
}

export class EditorData implements IEditorData {
  bookingCreateManagerSSREditorData: IBookingCreateManagerV2SSREditorData;
  validation?: any;

  constructor() {
    this.bookingCreateManagerSSREditorData = new BookingCreateManagerV2SSREditorData();
  }
}
